export const BREAKPOINTS = {
  MOBILE: 480,
  CONTENT_MAX: 700,
  ORG_NAV: 800,
  SIDENAV: 1000,
  TABLET: 1023,
} as const;

export const media = {
  mobile: `@media (max-width: ${BREAKPOINTS.MOBILE}px)`,
  contentMax: `@media (max-width: ${BREAKPOINTS.CONTENT_MAX}px)`,
  orgNav: `@media (max-width: ${BREAKPOINTS.ORG_NAV}px)`,
  sidenav: `@media (max-width: ${BREAKPOINTS.SIDENAV}px)`,
  tablet: `@media (max-width: ${BREAKPOINTS.TABLET}px)`,
} as const;
